import React from "react"
import { graphql, Link } from "gatsby"
import Img from "gatsby-image"
import Layout from "../components/layout"
import SEO from "../components/seo"

class IndexCategory extends React.Component {

  render() {

    const { data } = this.props;

    return (
      <React.Fragment>

        <div className="row product-main">
          {data.data.allProduct.nodes.map(items => (
            <div className="Catalogue__item col-sm-12 col-md-6 col-lg-4" key={items.id}>
              <div className="details_List">

                <Link to={`/${items.category[0].slug}/${items.slug}`}>

                  { items.productImage && items.productImage[0] ? <Img fluid={{
                      "src": `${process.env.GATSBY_FLOTIQ_BASE_URL}/image/1920x0/${items.productImage[0].id}.${items.productImage[0].extension}`,
                      "aspectRatio": 1.77,
                      "fluid": '',
                      "srcSet": ''
                  }} /> : <div className="no-image">No Image</div>}

                </Link>

                  <div className="details_inner">
                  <h2>
                    <Link to={`/${items.category[0].slug}/${items.slug}`}>{items.name}</Link>
                  </h2>
                  <div className="row">
                    <div className="col-sm-4 align-self-center">
                      <span className="price">${items.price}</span>
                    </div>
                    <div className="col-sm-8 text-right align-self-center">

                        {items.stock ? <div class="items-stock">Stock: {items.stock}</div> : <div class="items-stock">Out of Stock</div>}
                        {/* <a
                          href={`/${data.data.category.slug}`}
                          className="Product snipcart-add-item"
                          data-item-id={items.slug}
                          data-item-price={items.price}
                          data-item-stock={items.stock}
                          data-item-image={items.productImage && items.productImage[0] ? `${process.env.GATSBY_FLOTIQ_BASE_URL}/image/1920x0/${items.productImage[0].id}.${items.productImage[0].extension}` : ""} data-item-name={items.name} data-item-url={`/${data.data.category.slug}`}
                          data-item-custom1-name={items.options && items.options[0] ? `${items.options[0].optionName}` : ""}
                          data-item-custom1-options={items.options && items.options[0] ? `${items.options[0].optionVariations}` : ""}
                          data-item-custom2-name={items.options && items.options[1] ? `${items.options[1].optionName}` : ""}
                          data-item-custom2-options={items.options && items.options[1] ? `${items.options[1].optionVariations}` : ""}
                          data-item-custom3-name={items.options && items.options[2] ? `${items.options[2].optionName}` : ""}
                          data-item-custom3-options={items.options && items.options[2] ? `${items.options[2].optionVariations}` : ""}
                          data-item-custom4-name={items.options && items.options[3] ? `${items.options[3].optionName}` : ""}
                          data-item-custom4-options={items.options && items.options[3] ? `${items.options[3].optionVariations}` : ""}
                          data-item-custom5-name={items.options && items.options[4] ? `${items.options[4].optionName}` : ""}
                          data-item-custom5-options={items.options && items.options[4] ? `${items.options[4].optionVariations}` : ""}
                          data-item-custom6-name={items.options && items.options[5] ? `${items.options[5].optionName}` : ""}
                          data-item-custom6-options={items.options && items.options[5] ? `${items.options[5].optionVariations}` : ""}
                          data-item-custom7-name={items.options && items.options[6] ? `${items.options[6].optionName}` : ""}
                          data-item-custom7-options={items.options && items.options[6] ? `${items.options[6].optionVariations}` : ""}
                          data-item-custom8-name={items.options && items.options[7] ? `${items.options[7].optionName}` : ""}
                          data-item-custom8-options={items.options && items.options[7] ? `${items.options[7].optionVariations}` : ""}
                          data-item-custom9-name={items.options && items.options[8] ? `${items.options[8].optionName}` : ""}
                          data-item-custom9-options={items.options && items.options[8] ? `${items.options[8].optionVariations}` : ""}
                          data-item-custom10-name={items.options && items.options[9] ? `${items.options[9].optionName}` : ""}
                          data-item-custom10-options={items.options && items.options[9] ? `${items.options[9].optionVariations}` : ""}
                          data-item-custom11-name={items.options && items.options[10] ? `${items.options[10].optionName}` : ""}
                          data-item-custom11-options={items.options && items.options[10] ? `${items.options[10].optionVariations}` : ""}
                          data-item-custom12-name={items.options && items.options[11] ? `${items.options[11].optionName}` : ""}
                          data-item-custom12-options={items.options && items.options[11] ? `${items.options[11].optionVariations}` : ""}
                          data-item-custom13-name={items.options && items.options[12] ? `${items.options[12].optionName}` : ""}
                          data-item-custom13-options={items.options && items.options[12] ? `${items.options[12].optionVariations}` : ""}
                          data-item-custom14-name={items.options && items.options[13] ? `${items.options[13].optionName}` : ""}
                          data-item-custom14-options={items.options && items.options[13] ? `${items.options[13].optionVariations}` : ""}
                          data-item-custom15-name={items.options && items.options[14] ? `${items.options[14].optionName}` : ""}
                          data-item-custom15-options={items.options && items.options[14] ? `${items.options[14].optionVariations}` : ""}
                          data-item-custom16-name={items.options && items.options[15] ? `${items.options[15].optionName}` : ""}
                          data-item-custom16-options={items.options && items.options[15] ? `${items.options[15].optionVariations}` : ""}
                          data-item-custom17-name={items.options && items.options[16] ? `${items.options[16].optionName}` : ""}
                          data-item-custom17-options={items.options && items.options[16] ? `${items.options[16].optionVariations}` : ""}
                          data-item-custom18-name={items.options && items.options[17] ? `${items.options[17].optionName}` : ""}
                          data-item-custom18-options={items.options && items.options[17] ? `${items.options[17].optionVariations}` : ""}
                          data-item-custom19-name={items.options && items.options[18] ? `${items.options[18].optionName}` : ""}
                          data-item-custom19-options={items.options && items.options[18] ? `${items.options[18].optionVariations}` : ""}
                          data-item-custom20-name={items.options && items.options[19] ? `${items.options[19].optionName}` : ""}
                          data-item-custom20-options={items.options && items.options[19] ? `${items.options[19].optionVariations}` : ""}
                          data-item-custom21-name="Special comments"
                          data-item-custom21-type="textarea"
                        >
                          <i className="fas fa-shopping-bag" />
                            {items.stock ? "Add to Cart" : "Special Order"}
                        </a> */}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </React.Fragment>
    );
  }
}

const CategoryPage = data => (

  <Layout>
    <SEO title={data.data.category.name} keywords={[`Handmade`, `Crafts`, `${data.data.category.name}`]} ogTitle={data.data.category ? `${data.data.category.name}` : ""}  ogURL={data.data.category ? `https://pattyshomemadegifts.com/${data.data.category.slug}/` : ""} metaTitle={data.data.category ? `${data.data.category.name}` : ""} ogImage={data.data.category.image ? `${process.env.GATSBY_FLOTIQ_BASE_URL}/image/400x0/${data.data.category.image[0].id}.${data.data.category.image[0].extension}` : ""} metaCategory={data.data.category.name} ogDescription={data.data.category.name} twitterDescription={data.data.category.name} />
    <div className="container">
      <div className="text-center"><h1 className="with-underline">{data.data.category.name}</h1></div>
      <div className="text-center"><p className="category-description">
      <div dangerouslySetInnerHTML={{ __html: data.data.category.description }} />
      </p></div>
      <IndexCategory data={data} />
    </div>
  </Layout>
)

export default CategoryPage

export const query = graphql`
  query CategoryQuery($slug: String!) {
    allProduct(sort: {fields: flotiqInternal___createdAt, order: DESC}, filter: {category: {elemMatch: {slug: {eq: $slug}}}}) {

      nodes {
        id
        slug
        name
        price
        stock
        description
        productImage {
          id
          extension
        }
        productGallery {
          id
          extension
        }
        category {
            slug
            image {
              extension
              id
            }
        }
        options {
          optionName
          optionVariations
        }
      }
  }

  category(slug: {eq: $slug}) {
    name
    slug
    description
    image {
      extension
      id
    }
  }

  }
`



